// extracted by mini-css-extract-plugin
export default {"bgImage":"footer_bgImage__Wj-Ep","hover":"footer_hover__Xy13s"};